import pure from "refractor/pure";
export default pure;